import { useReducer } from "react";
import { Difficulty } from "shared/games/Difficulty";
import { GameAnswerMixPuzzle } from "shared/games/types/GameAnswers";
import { GameQuestionMixPuzzle } from "shared/games/types/GameQuestions";
import initState from "./initState";
import reducer from "./reducer";

interface FailedScreenState {
  type: "failed-screen";
  difficulty: Difficulty;
  mixPuzzle: GameQuestionMixPuzzle["mixPuzzle"];
  grade: GameAnswerMixPuzzle["grade"];
}

interface PlayingState {
  type: "game-screen";
  difficulty: Difficulty;
  mixPuzzle: GameQuestionMixPuzzle["mixPuzzle"];
  // This is a hack to allow us to load the answer as a mix. This is used in editing in the admin
  __loadAnswerAsMix?: boolean;
}

export type Params = FailedScreenState | PlayingState;

export default function useMixPuzzleState(params: Params) {
  return useReducer<typeof reducer>(reducer, initState(params));
}
